export default __webpack_public_path__ + "assets/models/ff2064bf59405469b89ac77190bec7cc.glb";